import { useQuery } from '@apollo/client'
import { RecruiterMe } from 'recruiter/graphql/admin.gql'
import { recruiterRouteConfig } from 'recruiter/routes'
import { TopNavigation } from 'shared/components/TopNavigation'
import { GlobalSearch } from './GlobalSearch'

const baseLinks = [
    {
        label: 'Research',
        path: recruiterRouteConfig.research.path,
    },
    {
        label: 'Searches',
        path: recruiterRouteConfig.rosters.path,
    },
    {
        label: 'Companies',
        path: recruiterRouteConfig.companies.path,
    },
]

export function RecruiterTopNavigation() {
    const { data } = useQuery(RecruiterMe)
    const isAdmin = data?.recruiterMe?.isAdmin ?? false
    const isBotAdmin = data?.recruiterMe?.isBotAdmin ?? false

    // Admin is the only top-level link for the admin surface. The
    // Recruiters page and the Bot Audit dashboard live as sub-tabs
    // under /admin, selected by AdminHeader. Show the link if the
    // user has access to either sub-page.
    const links = [
        ...baseLinks,
        ...(isAdmin || isBotAdmin
            ? [{ label: 'Admin', path: recruiterRouteConfig.admin.path }]
            : []),
    ]

    return <TopNavigation links={links} centerContent={<GlobalSearch />} />
}
